import "./StartPage_text.css";

import { Link } from "react-router-dom";

import portraitImg from "./images/portrait.png";

const HomeText = () => {
	const languages = [
		"Python",
		"C",
		"C++",
		"C#",
		"Java",
		"JavaScript",
		"HTML & CSS",
		"Matlab",
		"Assembly (ATmega16)",
		"VHDL",
	];
	const technologies = ["React", "Django", "Django REST framework"];
	const other = ["Git", "Linux", "GIMP"];

	return (
		<div className='text'>
			<h2 style={{marginBottom: "0px"}}>Hi!</h2>

			<div style={{ display: "block" }}>
				<p id='intro-text'>
					My name is Max. I'm a 27 year old web developer and computer science graduate. The formal name of the program I studied is 'Master of
					Science in Computer Science and Engineering'.
					The courses include software, hardware, and of course, a lot of
					mathematics. See more about the program&nbsp;
					<a
						href='https://liu.se/studieinfo/en/program/6cddd/4181'
						target='_blank'
						rel='noopener noreferrer'
					>
						here
					</a>
					&nbsp; (or in Swedish&nbsp;
					<a
						href='https://liu.se/studieinfo/program/6cddd/4181'
						target='_blank'
						rel='noopener noreferrer'
					>
						here
					</a>
					).
				</p>

				<img
					src={portraitImg}
					id='portrait-img'
					alt='portrait'
					style={{ borderRadius: "200px", marginLeft: "20px" }}
				/>
			</div>

			<p>
				I love programming and understanding how things work, especially
				computers, computer systems and robotics. My main interests in the
				computer science field are AI, data science, system security and web
				development.
			</p>

			<p>
				This website is my portfolio, containing
				some information about me, such as my education and work experience in{" "}
				<Link to='/about/work'>'About me'</Link>, things that I have made in{" "}
				<Link to='/projects'>'Projects'</Link> and how to get in touch with me
				in <Link to='/contact'>'Contact'</Link>.
			</p>

			<h2 style={{ marginTop: "40px" }}>Some skills and knowledge I have:</h2>

			<div className="skills-table-new">
				<span className="skills-title-new">Languages</span>
				<span>
					{languages.map((item) => (
						<div className='skill-item-new'>{item}</div>
					))}
				</span>
			</div>

			<div className="skills-table-wrapper">
				<div className="skills-table-new">
					<span className="skills-title-new">Technologies</span>
					<span>
						{technologies.map((item) => (
							<div className='skill-item-new'>{item}</div>
						))}
					</span>
				</div>
			</div>

			<div className="skills-table-new">
				<span className="skills-title-new">Other</span>
				<span>
					{other.map((item) => (
						<div className='skill-item-new'>{item}</div>
					))}
				</span>
			</div>
			
		</div>
	);
};

export default HomeText;
